import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useParams } from "react-router-dom";

import { CvTemplatesListPage } from "./cv_templates_list_page";
import { useCvTemplatesListPage } from "./use_cv_templates_list_page";

export const CvTemplatesCollectionController = () => {
  const { accountId } = useParams<{ accountId: string }>();
  const { fetch, cvTemplates, loaded, errors } = useCvTemplatesListPage(accountId);
  const WrappedActivityTemplatesListPage = usePageWrapper(CvTemplatesListPage);

  return (
    <WrappedActivityTemplatesListPage
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message="It looks like the cv templates page could not be loaded."
          buttonMessage="Please try to come back later"
          buttonUrl={`/saas_admin/accounts/${accountId}/cv_templates`}
        />
      }
      cvTemplates={cvTemplates?.collection}
      accountId={accountId}
      fetchTemplates={fetch}
    />
  );
};
